import React from 'react';

import BaseExerciseForm from 'modules/exercises/components/BaseExerciseForm';

import { FillInTheBlanksExerciseInput } from '../../types/form';
import { FillInTheBlanksExercise } from '../../types';
import { useFillInTheBlanksExerciseForm } from '../../hooks';
import FillInTheBlanksQuestionsForm from '../FillInTheBlanksQuestionsForm';

interface FillInTheBlanksExerciseFormProps {
  onSubmit: (input: FillInTheBlanksExerciseInput) => void;
  submitting: boolean;

  exercise?: FillInTheBlanksExercise;
  exercisesCount?: number;
}

const FillInTheBlanksExerciseForm = (props: FillInTheBlanksExerciseFormProps) => {
  const { onSubmit, submitting, exercise, exercisesCount = 0 } = props;
  const { useFormProps, getNextQuestion } = useFillInTheBlanksExerciseForm({
    exercise,
    exerciseIndex: exercisesCount,
  });

  return (
    <BaseExerciseForm onSubmit={onSubmit} submitting={submitting} useFormProps={useFormProps}>
      <FillInTheBlanksQuestionsForm getNextQuestion={getNextQuestion} />
    </BaseExerciseForm>
  );
};

export default FillInTheBlanksExerciseForm;
